/* Sake Numbers — entrance animation observer.

   IntersectionObserver one-shot pattern. Adds `.sn-in-view` to the section
   when it crosses 85% viewport. CSS transitions per [data-anim] child use
   `--i` for stagger. Mirrors the kubota-statement.js pattern.

   Loaded only when entrance_preset != 'none' (gated in the section liquid). */

(() => {
  const init = () => {
    const sections = document.querySelectorAll('.sake-numbers[data-entrance]:not([data-entrance="none"])');
    if (!sections.length) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
      if (reduce) {
        section.classList.add('sn-in-view');
        return;
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.classList.add('sn-in-view');
          io.unobserve(section);
        });
      }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
      io.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
